import { render, staticRenderFns } from "./TopupApprove.vue?vue&type=template&id=156da6f8&scoped=true"
import script from "./TopupApprove.vue?vue&type=script&lang=js"
export * from "./TopupApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156da6f8",
  null
  
)

export default component.exports